import React from 'react';
import styled from 'styled-components';
import { minBreakpointQuery, sectionMargins } from '../styles';
import { Container, Heading, HtmlContent } from './ui';

const StyledSpaDirections = styled.section`
  ${sectionMargins()};
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 20px;

  ${minBreakpointQuery.small`
    margin-bottom: 25px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 30px;
  `}
`;

const SpaDirections = ({ directions }) =>
  directions && (
    <StyledSpaDirections>
      <Container narrow={true}>
        <StyledHeading>How to get to the Spa?</StyledHeading>
        <HtmlContent html={directions} />
      </Container>
    </StyledSpaDirections>
  );

export default SpaDirections;
